import { sanitizeRichText } from "../../utils/sanitizeHtml";

const containsHtml = (value: string) => /<\/?[a-z][\s\S]*>/i.test(value);

/**
 * Renders an event description.
 *
 * New descriptions are sanitized rich-text HTML. Descriptions created before
 * the rich text editor are plain text (possibly with line breaks), so those
 * are rendered with whitespace preserved to keep their original layout.
 */
export const RenderRichText = ({
  children = "",
  className = "",
}: {
  children?: string | null;
  className?: string;
}) => {
  const content = children ?? "";

  if (!containsHtml(content)) {
    return (
      <div className={`rich-text whitespace-pre-wrap ${className}`}>
        {content}
      </div>
    );
  }

  return (
    <div
      className={`rich-text ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitizeRichText(content) }}
    />
  );
};
